import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/domains';
export var ScoreReport = /*#__PURE__*/function (_ValueObject) {
  _inherits(ScoreReport, _ValueObject);

  var _super = _createSuper(ScoreReport);

  function ScoreReport() {
    _classCallCheck(this, ScoreReport);

    return _super.apply(this, arguments);
  }

  _createClass(ScoreReport, [{
    key: "score",
    get: function get() {
      return this.props.score;
    }
  }, {
    key: "totalAttendeeAchieve",
    get: function get() {
      return this.props.totalAttendeeAchieve;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "validateBaseProps",
    value: function validateBaseProps(props) {
      var guardCollection = [{
        argument: props.score,
        argumentName: 'Score'
      }, {
        argument: props.totalAttendeeAchieve,
        argumentName: 'Total attendee achieve'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(props);
    }
  }, {
    key: "create",
    value: function create(props) {
      var validatedBasePropsOrError = this.validateBaseProps(props);

      if (validatedBasePropsOrError.isFailure) {
        return validatedBasePropsOrError;
      }

      return Result.ok(new ScoreReport(props));
    }
  }, {
    key: "createBasePropsFromJson",
    value: function createBasePropsFromJson(data) {
      var score = data.score,
          totalAttendeeAchieve = data.totalAttendeeAchieve;
      return Result.ok({
        score: score,
        totalAttendeeAchieve: totalAttendeeAchieve
      });
    }
  }]);

  return ScoreReport;
}(ValueObject);